import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Finding from './Finding';
import { findingType } from './types';
import './styles.sass';


const FindingsList = ({ findings, role }) => (
  <div className="findings-list">
    { findings.map(finding => <Finding key={finding.id} role={role} finding={finding} />) }
  </div>
);

FindingsList.propTypes = {
  findings: PropTypes.arrayOf(findingType).isRequired,
};

const mapStateToProps = (state, { withoutJurisdiction }) => ({
  findings: state.findings.get('findings').filter(x =>
    x.jurisdiction !== withoutJurisdiction),
  role: (withoutJurisdiction === '40' ? 'analyst' : 'responder'),
});

export default connect(mapStateToProps)(FindingsList);



// WEBPACK FOOTER //
// ./src/views/Components/Finding/List.js